const semverRegex = /(\d)+\.(\d)+\.(\d)+/
const onlySemver = /^(\d)+\.(\d)+\.(\d)+$/

function replaceUrlVersion(url, version) {
  return url && onlySemver.test(version) ? url.replace(semverRegex, version) : url
}

export default replaceUrlVersion



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/common/replaceUrlVersion.js